module.exports = __webpack_public_path__ + "static/media/64.0e86a223.jpg";